import React, { Component } from 'react';
import PropTypes from 'prop-types';

import getLastPageVisitedByScreenIdList from 'common/util/getLastPageVisitedByScreenIdList';

import {
  SCREEN_ID_PARTNER_OVERVIEW,
  SCREEN_ID_PARTNER_LISTING_HOUSEHOLD_CONNECT_BANK,
} from 'client/constants/screenIds';

import {
  DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS,
  DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_MOVE_INS,
} from 'common/dataTableConstants';

import {
  dataTable,
  actionDataTableReset,
  actionDataTableLoadItems,
  actionDataTableLoadItemsIfNotFullyLoaded,
  actionInitializeDataTableState,
} from 'client/helpers/dataTables';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withTransitionHook from 'client/helpers/withTransitionHook';

import PartnerActions from 'client/actions/Partner';
import NavigatorActions from 'client/actions/Navigator';

import SrConnectBankAccountForm from 'client/components/SrConnectBankAccountForm/SrConnectBankAccountForm';

function getHouseholdListingDataTableSettings({ match }) {
  const householdListingId = parseInt(match.params.householdListingId, 10);

  const dataTableSettings = {
    itemsPropName: 'household',
    dataSource: DATA_TABLE_SOURCE_HOUSEHOLD_LISTINGS,
    viewId: `by-household-listing-id-${householdListingId}`,
    count: 1,
    injectSingleItem: true,
    customParams: {
      householdListings: {
        householdListingId,
      },
    },
  };

  return dataTableSettings;
}

@withTransitionHook
@withScreenId(SCREEN_ID_PARTNER_LISTING_HOUSEHOLD_CONNECT_BANK)
@withScrollToTop
@dataTable(getHouseholdListingDataTableSettings)
@branch(({ match }) => ({
  partner: ['partners', 'bySlug', match.params.partnerSlug],
  screenIdHistory: ['analytics', 'screenIdHistory'],
  pathHistory: ['analytics', 'pathHistory'],
}))
class PartnerListingHouseholdConnectBankPage extends Component {
  static propTypes = {
    screenIdHistory: PropTypes.array.isRequired,
    pathHistory: PropTypes.array.isRequired,
  };

  static fetchData(match, inject) {
    const partner = inject.state.get(['partners', 'bySlug', match.params.partnerSlug]);
    const promises = [];

    if (!partner) {
      promises.push(
        PartnerActions.loadPartnerBySlug(inject, {
          slug: match.params.partnerSlug,
        }),
      );
    }

    const householdListingDataTableSettings = getHouseholdListingDataTableSettings({ match });
    actionInitializeDataTableState(inject, householdListingDataTableSettings);
    promises.push(
      actionDataTableLoadItemsIfNotFullyLoaded(inject, householdListingDataTableSettings),
    );

    return Promise.all(promises);
  }

  _onBack = () => {
    const { match, dispatch, screenIdHistory, pathHistory } = this.props;

    dispatch(actionDataTableLoadItems, getHouseholdListingDataTableSettings({ match }));
    dispatch(actionDataTableReset, {
      dataSource: DATA_TABLE_SOURCE_PARTNER_HOUSEHOLD_MOVE_INS,
    });

    const lastPageVisited = getLastPageVisitedByScreenIdList({
      screenIdHistory,
      pathHistory,
      screenIdList: [SCREEN_ID_PARTNER_OVERVIEW],
    });

    const redirectUrl =
      lastPageVisited?.screenId === SCREEN_ID_PARTNER_OVERVIEW
        ? `/partner/${match.params.partnerSlug}`
        : `/partner/${match.params.partnerSlug}/listing/${match.params.listingId}`;

    dispatch(NavigatorActions.goBack, {
      defaultTo: redirectUrl,
    });
  };

  render() {
    const { match, dispatch, household } = this.props;

    return (
      <SrConnectBankAccountForm
        dispatch={dispatch}
        household={household}
        listingId={parseInt(match.params.listingId, 10)}
        onBack={this._onBack}
        onSubmit={this._onBack}
      />
    );
  }
}

PartnerListingHouseholdConnectBankPage.displayName = 'PartnerListingHouseholdConnectBankPage';

export default PartnerListingHouseholdConnectBankPage;
